;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import { Dayjs } from 'dayjs';
import { ListingPositionEnum } from '@/lib/types/api/multi-livestream';

// Helper function that calculates how many columns a listing should span
// based on its position in the schedule window, the schedule,
// and other factors
const getListingGridColumnEndSpan = (
  listingPosition: ListingPositionEnum,
  scheduleStart: Dayjs,
  scheduleEnd: Dayjs,
  startTime: Dayjs,
  endTime: Dayjs,
  listingDuration: number
): string => {
  let span: number;
  let diff: number;
  switch (true) {
    case listingPosition ===
      ListingPositionEnum.startsBeforeScheduleStartButNotEnded:
      diff = scheduleStart.diff(startTime, 'minute');
      // trimming time from the beginning of the listing
      span = listingDuration - diff;
      break;
    case listingPosition ===
      ListingPositionEnum.duringScheduleEndsAfterScheduleEnd:
      diff = endTime.diff(scheduleEnd, 'minute');
      // trimming time from the end of the listing
      // the math from day js ends up with 1 minute too long for our layout
      // so we trim 1 more minute
      span = listingDuration - diff - 1;
      break;
    // in these three edge cases we just set the duration to the schedule window
    case listingPosition ===
      ListingPositionEnum.startsBeforeScheduleStartEndsAtScheduleEnd:
    case listingPosition ===
      ListingPositionEnum.startsAtScheduleStartEndsAfterScheduleEnd:
    case listingPosition === ListingPositionEnum.listingLongerThanSchedule:
      span = scheduleEnd.diff(scheduleStart, 'minute');
      break;
    // the majority use case - we set the listing to a span
    // equivelant to it's duration
    case listingPosition ===
      ListingPositionEnum.startsAtScheduleStartAndIsEnded:
    case listingPosition === ListingPositionEnum.duringSchedule:
    case listingPosition === ListingPositionEnum.startsAtScheduleStart:
    case listingPosition === ListingPositionEnum.listingSameAsSchedule:
    default:
      span = listingDuration;
      break;
  }
  return span.toString();
};

export { getListingGridColumnEndSpan };
